/** Console routes the help framework links to. */

/** Admin help content editor (Admin role or Help.Content.Manage). */
export const HELP_ADMIN_PATH = '/admin/help';

/** AI feature flags (Admin only): the HelpAssistant flag switches Ask AI on. */
export const AI_FEATURE_FLAGS_PATH = '/admin/ai/feature-flags';
